<nav class="navbar navbar-expand-md navbar-dark fixed-top p-0 shadow-sm">
    <div class="container-fluid">
        <div class="d-flex">
            <img [src]="user.CompanyLogo" alt="Company Logo" style="max-width: 170px;max-height: 40px;" />
        </div>
        <div class="" id="navbarsExample02">
            <div class="d-flex align-items-center">
                <span class="CompanyName mx-2" (click)="CompanySelection()">{{user.CompanyName}}</span>
                <!-- <i type="button" class="bi bi-bell-fill link-dark position-relative fs-5 mt-2">
                    <span class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-danger"
                        style="font-size: 10px;">
                        99+
                    </span>
                </i> -->
                <div class="nav-item text-nowrap ps-3">
                    <li ngbDropdown class="dropdown list-unstyled">
                        <span class="nav-link link-dark dropdown-toggle arrow-none nav-user px-2 align-items-center"
                            id="dropdownProfile" role="button" style="display: inline-flex;" ngbDropdownToggle>
                            <span class="account-user-avatar me-2">
                                <img src="assets\UserProfileImage\EmpDefaultImage.jpg"
                                    alt="user-image" width="35" class="rounded-circle">
                            </span>
                            <span class="d-lg-flex flex-column gap-0 d-none">
                                <span class="link-dark">{{user.UserName}}</span>
                                <span class="link-dark" style="font-size: small;">{{user.EDesignation}}</span>
                            </span>
                        </span>
                        <div ngbDropdownMenu aria-labelledby="dropdownProfile">
                            <!-- item-->
                            <div class=" dropdown-header noti-title">
                                <h6 class="text-overflow m-0">Welcome !</h6>
                            </div>

                            <!-- item-->
                            <span class="dropdown-item" (click)="Logout()">
                                <i class="mdi mdi-logout me-1"></i>
                                <span>Logout</span>
                            </span>
                        </div>
                    </li>
                </div>
            </div>
        </div>
    </div>
</nav>

<main class="d-flex flex-nowrap main-container">
    <div class="p-2 col overflow-auto">
        <router-outlet></router-outlet>
    </div>
</main>